var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.626,
    height: 18.804,
    viewBox: "0 0 14.626 18.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.545,21.215A2.1,2.1,0,0,0,10.634,23.3h8.358a2.1,2.1,0,0,0,2.089-2.089V8.679H8.545ZM22.126,5.545H18.469L17.425,4.5H12.2L11.156,5.545H7.5V7.634H22.126Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#de3c40"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.923e79c071f27e06aa664c064517eb29.svg";
export { ForwardRef as ReactComponent };